module.exports = __webpack_public_path__ + "assets/reports.74520aa3.svg";